import {vnModule} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule";
import {vnAppZone} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone";
import {accountDashboard} from "./accountDashboard";
import {menu_mod} from "./menu";
import {header} from "./header";
import {headerPromo} from "./headerPromo";
import {brandDashboard} from "./brandDashboard";
import {audienceOverview} from "./audienceOverview";
import {interactionOverview} from "./interactionOverview";
import {permalinkDetails} from "./permalinkDetails";
import {permalinkSearch} from "./permalinkSearch";
import {login} from "./login";
import {logs} from "./logs";
import {accountSettings} from "./accountSettings";
import {usageStats} from "./usageStats";
import {propertyManagement} from "./propertyManagement";
import {accountApi} from "./accountApi";
import {accountApiUsage} from "./accountApiUsage";
import {subscriptionManagement} from "./subscriptionManagement";
import {users} from "./users";
import {users_edit} from "./users_edit";
import {users_profile} from "./users_profile";
import {reset_password} from "./reset_password";
import {liveDashboard} from "./liveDashboard";
import {signup} from "./signup";
import {emailConfirmation} from "./emailConfirmation";
import {roles} from "../../vendor/valnet/valnet_jslib/vnApp/roles";
import {roles_edit} from "../../vendor/valnet/valnet_jslib/vnApp/roles_edit";
import {customDimensions} from "./customDimensions";
import {customEvents} from "./customEvents";
import {googleInsights} from "./googleInsights";
import {notificationOptOut} from "./notificationOptOut";
import { subHeader } from "./subHeader";
import {humanBotScoreDashboard} from "./humanBotScoreDashboard";
import {suspiciousRules} from "./suspiciousRules";

export class pageFactory{

        get_actionHandler(typeName :string, vnAppZone: vnAppZone) :vnModule{

            let obj :vnModule;
            console.log("Instantiating module ["+typeName+"]");

            switch (typeName)
            {
                case "accountDashboard" :
                    obj = new accountDashboard(vnAppZone);
                    break;
                case "menu" :
                    obj = new menu_mod(vnAppZone);
                    break;
                case "header" :
                    obj = new header(vnAppZone);
                    break;
                case "subHeader":
                    obj = new subHeader(vnAppZone);
                    break;
                case "headerPromo" :
                    obj = new headerPromo(vnAppZone);
                    break;
                case "login" :
                    obj = new login(vnAppZone);
                    break;
                case "account_settings" :
                    obj = new accountSettings(vnAppZone);
                    break;
                case "usage_stats" :
                    obj = new usageStats(vnAppZone);
                    break;
                case "property_management" :
                    obj = new propertyManagement(vnAppZone);
                    break;
                case "account_api" :
                    obj = new accountApi(vnAppZone);
                    break;
                case "account_apiUsage" :
                    obj = new accountApiUsage(vnAppZone);
                    break;
                case "subscription_management" :
                    obj = new subscriptionManagement(vnAppZone);
                    break;
                case "users" :
                    obj = new users(vnAppZone);
                    break;
                case "users_edit" :
                    obj = new users_edit(vnAppZone);
                    break;
                case "users_profile" :
                    obj = new users_profile(vnAppZone);
                    break;
                case "logs" :
                    obj = new logs(vnAppZone);
                    break;
                case "reset_password" :
                    obj = new reset_password(vnAppZone);
                    break;
                case "roles" :
                    obj = new roles(vnAppZone);
                    break;
                case "roles_edit" :
                    obj = new roles_edit(vnAppZone);
                    break;
                case "live_dashboard" :
                    obj = new liveDashboard(vnAppZone);
                    break;
                case "audience_overview" :
                    obj = new audienceOverview(vnAppZone);
                    break;
                case "interaction_overview" :
                    obj = new interactionOverview(vnAppZone);
                    break;
                case "permalink_details" :
                    obj = new permalinkDetails(vnAppZone);
                    break;
                case "permalink_search" :
                    obj = new permalinkSearch(vnAppZone);
                    break;
                case "brand_dashboard" :
                    obj = new brandDashboard(vnAppZone);
                    break;
                case "human_bot_score" :
                    obj = new humanBotScoreDashboard(vnAppZone);
                    break;
                case "signup" :
                    obj = new signup(vnAppZone);
                    break;
                case "email_confirmation" :
                    obj = new emailConfirmation(vnAppZone);
                    break;
                case "suspicious_rules":
                    obj = new suspiciousRules(vnAppZone);
                    break;
                case "custom_dimensions":
                    obj = new customDimensions(vnAppZone);
                    break;
                case "custom_events":
                    obj = new customEvents(vnAppZone);
                    break;
                case "google_insights":
                    obj = new googleInsights(vnAppZone);
                    break;
                case "notification_optOut":
                    obj = new notificationOptOut(vnAppZone);
                    break;
                default:
                    break;
            }

            return obj;
        }
    }



// WEBPACK FOOTER //
// ./js/modules/factory.ts